import { render, staticRenderFns } from "./openapi.vue?vue&type=template&id=010fd89a&scoped=true"
import script from "./openapi.vue?vue&type=script&lang=js"
export * from "./openapi.vue?vue&type=script&lang=js"
import style0 from "./openapi.vue?vue&type=style&index=0&id=010fd89a&prod&scoped=true&lang=css"
import style1 from "./openapi.vue?vue&type=style&index=1&id=010fd89a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010fd89a",
  null
  
)

export default component.exports